import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
	selector: "toggle-input-ui",
	templateUrl: "./toggle-input.component.html",
	styleUrls: ["./toggle-input.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: ToggleInputUIComponent,
			multi: true
		}
	],
	standalone: false
})
export class ToggleInputUIComponent implements ControlValueAccessor {
	@Output() public valueToggle: EventEmitter<boolean> = new EventEmitter<boolean>();
	public onChange = (value: boolean): void => {
		this.toggle = value;
		this.valueToggle.emit(value);
	};
	public onTouched: () => void;

	public toggle: boolean;
	public isDisabled = false;

	constructor(private _cdr: ChangeDetectorRef) {}

	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}
	writeValue(val: boolean): void {
		this.toggle = val;
		this._cdr.markForCheck();
	}
	registerOnChange(fn: (val: boolean) => void): void {
		this.onChange = fn;
	}

	setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
		this.toggle = false;
		this._cdr.markForCheck();
	}

	toggleHandler(): void {
		this.toggle = !this.toggle;
		this.onChange(this.toggle);
	}
}
